export var ENTITY = "scheduled-export";
export var REDUCER_KEY = "SCHEDULED_EXPORT";
export var BASE_PATH_ENTITY = "scheduled-exports";
export var GENERATOR_PARAMS = {
    entity: ENTITY,
    reducerKey: REDUCER_KEY,
    basePathEntity: BASE_PATH_ENTITY,
};
